<template>
  <div :class="['swiper-container',them]">
    <van-swipe @change="onChange" :show-indicators="false" class="my-swipe" :loop="true" indicator-color="white" >
      <van-swipe-item v-for="(item, index) in renderList" :key="index">
        <div class="items-contaienr" >
          <div class="item" v-for="(mi,_i) in item" :key="_i" @click="linkUrl(mi.linkUrl)">
            <img :src="`${mi.icon}?v=1.74`" class="icon" />
            <p class="name">{{mi.equityName}}</p>
            <span class="price">会员价￥{{mi.memberPrice}}</span>
            <span class="line-through">售价￥{{mi.price}}</span>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    
    <div class="indicator" v-if="list.length>4">
      <span v-for="(item,index) in renderList.length" :class="{active: index == current}"  :key="item"></span>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import iconWyy from '../images/icon_wangyiyun.png'
import { mapActions } from 'vuex'

export default {
  name: 'swiper',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    isVip: {
      type: Boolean,
      default: false
    },
    tapType: {
      type: String,
      default: ''
    },
    vipStatus: {
      type: String,
      default: ''
    },
    them: {
      type: String,
      default: 'dark'
    }
  },
  data () {
    return {
      iconWyy,
      current: 0,
      pending: false,
      renderList: []
    }
  },
  watch: {
    list: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val && val.length) {
          const _length = Math.ceil(val.length / 4)
          for (let index = 0; index < _length; index++) {
            const element = val.slice(index * 4, index * 4 + 4)
            this.renderList[index] = element
          }
        }
      }
    }
            
  },
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem
  },
  methods: {
    ...mapActions('vip', [ 'getToken' ]),

    onChange (index) {
      this.current = index
    },
    async linkUrl (url) {
      if (this.vipStatus === 'FROZEN') {
        return
      }
      const _taget = this.tapType === 'hot' ? 1 : 2
      this.$report({
        id: 10237,
        args: { target: _taget }
      })
                
      if (url && this.isVip) {
        if (this.vipStatus === 'EXPIRED') {
          this.$emit('show-pass')
          return
        }
        if (this.pending) return
        this.pending = true
        const res = await this.getToken({
          benefitType: url.indexOf('oakvip') > -1 ? 'LIFE' : 'MONEY_SAVING_CARD'
        })
        if (res.success && res.data) {
          if (url.indexOf('oakvip') > -1) {
            window.location.href = `${url}&once=${res.data.onceToken}&return_url=${encodeURIComponent(window.location.href)}`
          } else {
            window.location.href = `${url}&user_token=${res.data.jwtToken}&return_url=${encodeURIComponent(window.location.href)}`
          }
        }
        this.pending = false
      } else {
        this.$emit('show-welfare', this.tapType)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.indicator {
  text-align: center;
  margin-top: 10px;
    span {
      display: inline-block;
      border-radius: 100%;
      margin-left: 10px;
      width: 14px;
      height: 14px;
      background: rgba(216, 216, 216, 0.2);
      &.active {
        background: #D8D8D8;
      }
    }
  }
.swiper-container {
  width: 670px;
  height: 280px;
  margin: auto;
  background: linear-gradient(180deg, #4F506E 0%, #3A3B53 100%);
  &.light{
    background: #FFF2E5;
  }
  border-radius: 20px;
  .my-swipe   {
    height: 100%;
    .van-swipe-item  {
      height: 100%;
      .items-contaienr {
        display: flex;
        height: 100%;
        padding: 0 20px;
        justify-content: space-around;
        .item {
          display: flex;
          padding: 30px 0;
          height: 100%;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          .icon {
            width: 80px;
            height: 80px;
            border-radius: 100%;
          }
          .name {
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #fff;
            line-height: 37px;
            margin-top: 10px;
          }
          .price{
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFD8BC;
            line-height: 33px;
            margin-top: 20px;
          }
          .line-through {
            height: 30px;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #777777;
            line-height: 30px;
            text-decoration: line-through;
          }
        }
      }
    }
  }
}
</style>